<template>
  <div>
    <!-- Modal Here -->
    <div>
      <Modal
        :isActive="isActive"
        :data="activeRow"
        @hideModal="isActive = false"
      />
    </div>

    <!-- Search/Upload Region Here -->
    <div class="search-holder">
      <!-- Search Input here -->
      <div class="input-holder">
        <Search
          placeholder="SEARCH BY LIST NAME OR FILE NAME"
          @input="value => (searchQuery = value)"
        />
      </div>

      <!-- Button Here -->
      <div class="button-region">
        <!-- download Template -->
        <!-- <div class="template">
          <DownloadTemplate />
        </div> -->
        <UploadButton class="upload-button" @import="handleImport" />
      </div>
    </div>

    <!--Table Here -->
    <vue-good-table
      :columns="columns"
      :rows="resultQuery"
      styleClass="vgt-table recipients-table"
      :pagination-options="{
        enabled: false,
        mode: 'records',
        perPage: 50,
        perPageDropdown: [10, 15, 20],
        dropdownAllowAll: false,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page',
        allLabel: 'All'
      }"
    >
      <template slot="table-row" slot-scope="recipientList">
        <!-- created_at Field here -->
        <span v-if="recipientList.column.field === 'created_at'">
          {{ recipientList.row[recipientList.column.field] | date }}
        </span>

        <!-- File Name region Here -->
        <span v-else-if="recipientList.column.field === 'file_name'">
          <input
            v-if="editRow.id === recipientList.row.id"
            type="text"
            class="name"
            v-model="data[recipientList.row.id]"
          />

          <span v-else>
            {{ recipientList.row[recipientList.column.field] }}</span
          >
        </span>

        <!-- Edit Region Here -->
        <span v-else-if="recipientList.column.field === 'edit'">
          <button
            class="button-gemnote"
            v-if="editRow.id === recipientList.row.id"
            @click="handleModification(recipientList.row, 'save')"
          >
            <span>
              Save
            </span>
          </button>
          <span
            v-else
            class="view-recipient"
            @click="handleModification(recipientList.row, 'edit')"
            >Edit</span
          >
        </span>

        <!-- View Details Region Here -->
        <span
          v-else-if="recipientList.column.field === 'view'"
          class="view-recipient"
          @click="$router.push(`/recipient-list/${recipientList.row.id}`)"
        >
          View
        </span>

        <!-- Delete Region Here -->
        <span
          v-else-if="
            recipientList.column.field === 'delete' &&
              recipientList.row.deletable
          "
          class="delete"
          @click="handleDelete(recipientList.row)"
        >
          x
        </span>
      </template>

      <div slot="emptystate">
        There are no items to display.
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { progressStatus, scrollPageToTop } from '../../helpers'
import moment from 'moment'
import { mapState } from 'vuex'
import UploadButton from './UploadButton.vue'
import Search from '@/components/Universal/Search.vue'

export default {
  name: 'RecipientList',

  props: {
    recipients: {
      type: Array,
      default: () => []
    }
  },

  filters: {
    date(value) {
      if (!value) return
      return moment(value).format('MM/DD/YYYY')
    }
  },

  components: {
    VueGoodTable,
    UploadButton,
    Search,
    Modal: () => import('./DeleteModal.vue')
  },

  data: () => ({
    isActive: false,
    data: [],
    editRow: {},
    activeRow: {},
    searchQuery: '',
    columns: [
      {
        label: 'Date Created',
        field: 'created_at'
      },

      {
        label: 'Created By',
        field: 'user'
      },

      {
        label: 'List Name',
        field: 'file_name',
        width: '17%'
      },

      {
        label: 'Recipient Count',
        field: 'totalRecords'
      },

      {
        label: '',
        field: 'edit'
      },

      {
        label: '',
        field: 'view'
      },

      {
        label: '',
        field: 'delete'
      }
    ]
  }),

  computed: {
    ...mapState({
      loading: state => state.recipient.loadRecipientList
    }),
    resultQuery() {
      if (this.searchQuery) {
        return this.recipients.filter(recipient => {
          return this.searchQuery
            .toLowerCase()
            .split(' ')
            .every(v => recipient.file_name.toLowerCase().includes(v))
        })
      } else {
        return this.recipients
      }
    },
    loadStatus() {
      return progressStatus(this.loading)
    }
  },

  mounted() {
    scrollPageToTop()
  },

  methods: {
    handleModification(row, action) {
      if (action === 'edit') {
        this.editRow = row
        this.data[row.id] = row.file_name
      } else {
        this.$store.dispatch('recipient/handleEditRecipientList', {
          id: row.id,
          name: this.data[row.id]
        })
      }
    },

    handleDelete(row) {
      this.isActive = true
      this.activeRow = row
    },

    handleImport(file) {
      this.$store.dispatch('recipient/handleImportRecipients', file)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-holder {
  display: flex;
  align-items: center;
  margin: 1.25rem 0;

  .input-holder {
    width: 35%;

    input {
      width: 100%;
      height: 30px;
      font-size: 0.875rem;
      border-bottom: 1px solid #979797;

      &::placeholder {
        color: #7b7a7a;
        font-size: 0.875rem;
      }
    }
  }

  .button-region {
    display: flex;
    align-items: center;
    margin-left: auto;

    .template {
      margin-right: 2rem;
    }
  }
}

.view-recipient {
  font-size: 0.813rem;
  color: #24292c;
  text-decoration-color: #a8a9ab;
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
  display: flex;
  justify-content: center;

  &:hover {
    opacity: 0.6;
  }
}

.delete {
  cursor: pointer;
  color: #25282a;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  font-size: 0.813rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.name {
  height: 30px;
  font-size: 0.875rem;
  color: #24292c;
  border: 1px solid #25282a;
  padding: 0 0.75rem;
}

.button-gemnote {
  display: flex;
  justify-content: center;
  width: 60px;
  height: 24px;
  border: none;
  font-size: 0.625rem;
}
</style>
